import styled from "styled-components"
import { device } from "breakpoints"

export const ImgTextCustomContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 30px auto;
  background: #008cd1;
  border-radius: 4px;
  max-width: 1160px !important;
  overflow: hidden;

  @media ${device.tablet} {
    flex-direction: row;
    width: 100%;
    align-items: center;
  }

  @media ${device.desktop} {
    margin: 60px auto;
  }

  :hover {
    .avenueBtn {
      background: #de720e;
    }
  }

  .icon {
    position: absolute;
    z-index: 3;

    :nth-of-type(1) {
      top: 20px;
      left: -20px;

      @media ${device.desktop} {
        top: 30px;
        left: -30px;
      }

      @media ${device.large} {
        top: 30px;
        left: -40px;
      }
    }

    :nth-of-type(2) {
      top: 104px;
      left: 30px;

      @media ${device.desktop} {
        top: 150px;
        left: 40px;
      }

      @media ${device.large} {
        top: 180px;
        left: 50px;
      }
    }
  }
`
export const ImgWrapper = styled.div`
  padding-top: 68%;
  position: relative;

  @media ${device.tablet} {
    position: static;
    padding-top: 0;
    width: 50%;
    min-height: 100% !important;
    height: 100%;
  }

  .avenueImg {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px 4px 0 0;

    @media ${device.tablet} {
      width: 50%;
      border-radius: 4px 0 0 4px;
    }
  }
`

export const TextWrapper = styled.div`
  padding: 20px;
  padding-bottom: 30px;
  text-align: center;
  @media ${device.tablet} {
    text-align: left;
    width: 50%;
    padding: 50px;
  }

  @media ${device.desktop} {
    padding: 70px;
    padding-bottom: 75px;
  }

  h3 {
    font-size: 24px;
    margin-bottom: 13px;
    width: 100%;
    color: white;

    @media ${device.desktop} {
      font-size: 32px;
      margin-bottom: 24px;
      line-height: 125%;
    }

    a {
      color: inherit;
      width: 100%;

      :before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }
  }

  p {
    width: 100%;
    font-size: 16px;
    margin-bottom: 20px;
    color: white;

    @media ${device.desktop} {
      font-size: 18px;
      margin-bottom: 34px;
    }
  }

  > *:last-child {
    margin-bottom: 0;
  }
`
